import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

// Services
import { HazardServices } from '../../Services/HazardServices';
import { InductryMasterServices } from '../../Services/InductryMaster';
import { UserHazardService } from '../../Services/UserHazardService';
import { CheckAuth } from '../../Services/UtilityService';

// Models
import { hazardMaster } from '../../Models/HazardMasterModel';
import { CompanyModel } from '../../Models/CompanyModel';
import { CommentStmt } from '@angular/compiler';
import { inductryMaster } from '../../Models/InductryMasterModel';
import { UserHazardModel } from '../../Models/UserHazardModel';
//import { debounce } from 'rxjs/operator/debounce';
//import { fakeAsync } from '@angular/core/testing';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressBarModule } from 'primeng/progressbar';
import { LoginComponent } from '../login/login.component';

@Component({
  templateUrl: './HazardPreference.component.html'
})

export class HazardPreference implements OnInit {
  tokenKey: string = "";
  userID: number;
  hMaster: hazardMaster[];
  filterhMaster: hazardMaster[];
  finalhMaster: number[] = [];
  uHazardModel = new UserHazardModel();
  uHazard: UserHazardModel[] = [];
  inductryMaster: inductryMaster[];
  selectedAll: any;
  companyObject = new CompanyModel();
  statusCode: number;
  isCheckDuplicateInductryinArray: boolean = false;
  currentIndex: number = 0;
  indSelectedIndex: number = 0;

  Preferences = new FormGroup({
    inductryList: new FormControl(''),
  });
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showerror(msg) {
    this.errorMessage = msg;
    this.isshowerror = true;
    window.scrollTo(0, 0);
  }
  hideerror() {
    this.errorMessage = "";
    this.isshowerror = false;
  }

  value: number = 0;
  errorMessage: any;
  isshowerror: boolean;

  constructor(private router: Router, private hazardServices: HazardServices, private inductryServices: InductryMasterServices, private userHazardService: UserHazardService, private checkAuth: CheckAuth, private logincomp: LoginComponent) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('UserId'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.GetUserHazard();
    this.isshowerror = false;
    this.isShowprogressSpinner = false;
    this.unblockDocument();
    this.GetHazardMaster(0);
    this.GetInductryMaster();
  }

  GetHazardMaster(industryId: number): void {
    //this.hazardServices.GetHazardMaster(this.tokenKey).subscribe(
    this.hazardServices.GetHazardMasterFindByUserID(this.tokenKey, this.userID, industryId).subscribe(
      data => {
        if (data["hazardMaster"] != null) {
          this.hMaster = data["hazardMaster"];
          this.filterhMaster = this.hMaster;
        }
        else {
          this.showerror(data["status"]);
        }
      },
      error => this.statusCode = error,
    );
  }

  GetInductryMaster(): void {
    this.inductryServices.GetInductryMaster(this.tokenKey).subscribe(
      data => {
        debugger;
        if (data["inductryMaster"] != null) {
          this.inductryMaster = data["inductryMaster"]
        }
        else {
          this.showerror(data["status"]);
        }

      },
      error => this.statusCode = error,
    );
  }

  filterForeInductry(filterVal: any) {
    //if (filterVal == 0) {
    //  this.hMaster = this.filterhMaster;
    //}
    //else {
      //this.hMaster = this.filterhMaster.filter((item) => item.industryId == filterVal);
      this.GetHazardMaster(filterVal);
    //}
  }

  selectAllInductry(event: any) {
    for (var i = 0; i < this.hMaster.length; i++) {
      this.hMaster[i].isSelected = event.currentTarget.checked;
      if (event.currentTarget.checked) {
        this.finalhMaster.push(parseInt(this.hMaster[i].hazardMasterId));
      }
      else {
        this.finalhMaster = [];
      }
    }
  }

  pushInductryInArray(id: any, event: any) {
    if (this.finalhMaster != undefined) {
      if (this.finalhMaster.length > 0) {
        for (let iCounter = 0; iCounter < this.finalhMaster.length; iCounter++) {
          if (this.finalhMaster[iCounter] == id) {
            this.currentIndex = iCounter;
            this.isCheckDuplicateInductryinArray = true;
          }
        }
      }
      else
        this.isCheckDuplicateInductryinArray = false;
    }

    if (this.isCheckDuplicateInductryinArray == false) {
      this.finalhMaster.push(id);
    }
    else {
      this.finalhMaster.splice(this.currentIndex, 1);
    }
  }

  savePreferences(Preferences: any) {
    this.blockDocument();
    if (this.finalhMaster.length > 0) {
      for (let iCouter = 0; iCouter < this.finalhMaster.length; iCouter++) {
        this.uHazardModel = new UserHazardModel();
        this.uHazardModel.Userid = this.userID;
        this.uHazardModel.HazardMasterId = parseInt(this.finalhMaster[iCouter].toString());
        this.uHazardModel.CreatedBy = this.userID;
        this.uHazard.push(this.uHazardModel);
      }
      this.userHazardService.SaveHazardMaster(this.tokenKey, this.uHazard)
        .subscribe(successCode => {
          //this.statusCode = successCode;
          if (successCode["userHazardId"] > 0) {
            this.router.navigateByUrl('/Dashboard');
          }
          else {
            this.showerror(successCode["status"]);
            this.unblockDocument();
          }
        }, errorCode => this.statusCode = errorCode);
      this.finalhMaster = [];
    }
    else {
      this.showerror("Please Select at list one Hazard");
      this.unblockDocument();
    }
  }

  GetUserHazard(): void {
    this.hazardServices.GetHazardMasterFindByUserID(this.tokenKey, this.userID,0).subscribe(
      data => {
        if (data["hazardMaster"] != null && data["hazardMaster"] != undefined) {
          let obj = data["hazardMaster"].filter((item) => item.isSelected == true);
          if (obj.length > 0) {
            this.router.navigate(['/Dashboard']);
          }
        }
      },
      error => this.statusCode = error,
    );
  }

  SkipStep(): void {
    this.router.navigate(['/Dashboard']);
  }
}
